import { Dayjs } from 'dayjs';
import { PromotionStatus, PromotionTemplate } from '@/models/promotion.model';

export enum CouponFormFields {
  CODE = 'code',
  DATE_FROM = 'dateFrom',
  DATE_TO = 'dateTo',
  RATE = 'rate',
  MIN_ORDER_AMOUNT = 'minOrderAmount',
  TEMPLATE = 'templateNumber',
  POPUP_TITLE = 'name',
  POPUP_DESCRIPTION = 'description',
  STATUS = 'status',
}

export type TCreateCouponFormValues = {
  [CouponFormFields.CODE]: string;
  [CouponFormFields.DATE_FROM]?: Dayjs;
  [CouponFormFields.DATE_TO]?: Dayjs;
  [CouponFormFields.RATE]: number | string;
  [CouponFormFields.MIN_ORDER_AMOUNT]: number;
  [CouponFormFields.POPUP_TITLE]: string;
  [CouponFormFields.POPUP_DESCRIPTION]: string;
  [CouponFormFields.STATUS]?: PromotionStatus;
  [CouponFormFields.TEMPLATE]: PromotionTemplate;
};
